import React from "react";
import { CustomProfile } from "../Components/MainComponents";

const ProfilePage = () => {
  return <CustomProfile />;
};

export default ProfilePage;
